export function initArchiveInvite() {

  console.log('Init Archive Invite');

  const searchGuest = document.getElementById("searchGuest");
  const showAll = document.getElementById("showAll");

  var showAllClicked = false;

  if (searchGuest){
    var timer;
    searchGuest.addEventListener("keyup", function (e) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          applySearch(searchGuest.value);
        }, 200)
    })
  }

  if (showAll){
    showAll.addEventListener("click", function (e) {
      e.preventDefault();
      showAllClicked = true;
      this.style.display = "none";
      applySearch(searchGuest.value)
    })
  }

  function applySearch(value) {
    const items = document.getElementsByClassName("invite__preview");
    [...items].forEach(function (item, index) {
      if (!showAllClicked && value === "" && index >= 8) item.style.display = "none";
      else {
        if (item.innerHTML.toLowerCase().includes(value.toLowerCase())) item.style.display = "block";
        else item.style.display = "none";
      }
    });
  }

}


